
export const SET_PROMOTIONS_LIST = "SET_PROMOTIONS_LIST";
export const SET_SELECRED_PROMOTIONS = 'SET_SELECRED_PROMOTIONS'
export const SET_SELECTED_PROMOTIONS_TOTAL_DISCOUNT="SET_SELECTED_PROMOTIONS_TOTAL_DISCOUNT"

export const SETPROMOTIONSLIST = (data: any) => {
    return {
        type: SET_PROMOTIONS_LIST,
        payload: data
    }
}
export const SETSELECTEDPROMOTIONS = (data: any) => {
    return {
        type: SET_SELECRED_PROMOTIONS,
        payload: data
    }
}
export const SETSELECTEDPROMOTIONSTOTALDISCOUNT=(data:any)=>{
    return {
        type:SET_SELECTED_PROMOTIONS_TOTAL_DISCOUNT,
        payload:data
    }
}
const initialState: object = {
    promotionsList: [],
    selectedPromotions: [],
    selectedPromotionTotalDiscount:0,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case SET_SELECTED_PROMOTIONS_TOTAL_DISCOUNT:
            return{
                ...state,
                selectedPromotionTotalDiscount:payload
            }
        case SET_PROMOTIONS_LIST:
            return {
                ...state,
                promotionsList: payload
            }
        case SET_SELECRED_PROMOTIONS:
            return {
                ...state,
                selectedPromotions: payload
            }
        default:
            return state;
    }
};

export default reducer;
